export default {
  clientId: import.meta.env.VITE_APP_SSO_AZURE_MEDTRONIC_CLIENT_ID as string,
  authority: import.meta.env.VITE_APP_SSO_AZURE_MEDTRONIC_AUTHORITY_URL as string
};
